module.exports = __webpack_public_path__ + "38147a85160b850deb6617169fc52ef6.pdf";